import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isPortrait: true,
        isTouchDevice: false,
        headerHeight: 50,
        articlesLength: 0,
        prevArticleIdx: -1,
        activeArticleIdx: 0,
        articlesEntered: false,
        view: 'intro',
        onIE: false,
        clickedIntroNavBtn : false,
        magicAllowed: true // for keeping Scroll Magic Scenes from firing when we don't want them to
    },
    getters: {
        getArticlesEnteredState: state => state.articlesEntered,
        getView: state => state.view
    },
    mutations: {
        checkDeviceSize (state, bool) {
            state.isPortrait = bool;
        },
        checkForTouch (state, bool) {
            state.isTouchDevice = bool;
        },
        getHeaderHeight (state, num) {
            state.headerHeight = num;
        },
        getArticlesLength (state, num) {
            state.articlesLength = num;
        },
        setPrevArticleIdx (state, num) {
            state.prevArticleIdx = num;
        },
        setActiveArticleIdx (state, num) {
            state.activeArticleIdx = num;
        },
        setArticlesEntered (state, bool) {
            state.articlesEntered = bool;
        },
        setView (state, view) {
            state.view = view;
        },
        checkIE (state, bool) {
          state.onIE = bool;
        },
        clickedIntroNavBtn (state, bool) {
            state.clickedIntroNavBtn = bool;
        },
        allowMagic (state, bool) {
            state.magicAllowed = bool;
        }
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js